import { css } from '@emotion/react'
import {
  SAmazonContainer,
  SAuthorContainer,
  SContainer,
  SContentContainer,
  SImageContainer,
} from './DigitalLegacyHero.styled'
import { Stack } from 'components/Stack'

import { Text, Title, Title_h1_default } from 'components/Typography'

import AmazonCTA from 'images/extra-svg/AmazonCTA.svg'
import AmazonStars from 'images/extra-svg/AmazonStars4_5.svg'

import { forwardRef } from 'react'
import { BREAKPOINTS, pxToRem } from 'utils/styled'

export const DigitalLegacyHero = forwardRef<
  HTMLDivElement,
  {
    title?: string | null
    description?: string | null
    viewReviewUrl?: string | null
    purchaseUrl?: string | null
    className?: string
  }
>((props, ref) => {
  return (
    <SContainer className={props.className} ref={ref} as="section" orientation="horizontal">
      <SImageContainer>
        <img
          src="/digital-legacy/ebookReader.jpg"
          srcSet="/digital-legacy/ebookReader.jpg 1x, /digital-legacy/ebookReader@2x.jpg 2x"
          alt="eBook Reader"
          css={css`
            max-width: ${pxToRem(244)}rem;

            @media ${BREAKPOINTS.LG.max} {
              width: 40vw;
              position: absolute;
            }
          `}
        />
        <img
          src="/digital-legacy/cover@2x.jpg"
          srcSet="/digital-legacy/cover@2x.jpg 1x, /digital-legacy/cover@3x.jpg 2x"
          alt="Digital Legacy book cover"
          css={css`
            border-radius: 7px;
            filter: drop-shadow(0px 4px 120px rgba(0, 0, 0, 0.3));
            transform: translateX(-40%);
            max-width: ${pxToRem(300)}rem;

            @media ${BREAKPOINTS.LG.max} {
              width: 50vw;
              transform: translateX(40%);
            }
          `}
        />
      </SImageContainer>

      <SContentContainer space={`${pxToRem(32)}rem`}>
        <Title variant={Title_h1_default}>{props.title}</Title>

        <SAuthorContainer orientation="horizontal" space="1rem">
          <img
            src="/digital-legacy/authors.jpg"
            srcSet="/digital-legacy/authors.jpg 1x, /digital-legacy/authors@2x.jpg 2x"
            alt="Rikard Steiber, Daniel Sieberg"
            css={{ position: 'relative', zIndex: -1 }}
          />
          <Text>{props.description}</Text>
        </SAuthorContainer>
        <SAmazonContainer orientation="horizontal" space={`${pxToRem(24)}rem`}>
          <a href={props.purchaseUrl ?? undefined} target="_blank" rel="noreferrer">
            <AmazonCTA css={{ cursor: 'pointer' }} />
          </a>
          <Stack orientation="horizontal" space={`${pxToRem(8)}rem`} css={{ alignItems: 'center' }}>
            <AmazonStars />
            <a href={props.viewReviewUrl ?? undefined} target="_blank" rel="noreferrer">
              <Text css={{ textDecoration: 'underline', cursor: 'pointer' }}>Read all reviews</Text>
            </a>
          </Stack>
        </SAmazonContainer>
      </SContentContainer>
    </SContainer>
  )
})

DigitalLegacyHero.displayName = 'DigitalLegacyHero'
